import { Injectable } from '@angular/core';

const SERVER_TZ = 'America/Phoenix';
declare var appSettings: any;

@Injectable()
export class AppSettings {
    api: AppSettings.ApiSettings;
    asqAppointmentsUrl: string;
    asqReceptionUrl: string;
    help: AppSettings.HelpSettings;
    helpDesk: AppSettings.HelpDeskSettings;
    notification: AppSettings.NotificationSettings;
    omega: AppSettings.OmegaSettings;
    productVersion: string;
    fullCalendarLicenseKey: string;
    screenRefresh: AppSettings.ScreenRefreshSettings;
    connectionMonitor: AppSettings.ConnectionMonitorSettings;
    security: AppSettings.SecuritySettings;
    timeZone: string;
    userManagement: AppSettings.UserManagementSettings;
    securePhotoUpload: boolean;
    vls: AppSettings.VlsSettings;
    aamvaSettings: AppSettings.AamvaFeatureSettings;

    constructor(settings?: AppSettings) {
        if (settings) {
            this.api = new AppSettings.ApiSettings(settings.api);
            this.asqAppointmentsUrl = settings.asqAppointmentsUrl;
            this.asqReceptionUrl = settings.asqReceptionUrl;
            this.help = new AppSettings.HelpSettings(settings.help);
            this.helpDesk = new AppSettings.HelpDeskSettings(settings.helpDesk);
            this.notification = new AppSettings.NotificationSettings(settings.notification);
            this.omega = new AppSettings.OmegaSettings(settings.omega);
            this.productVersion = settings.productVersion;
            this.fullCalendarLicenseKey = settings.fullCalendarLicenseKey;
            this.screenRefresh = new AppSettings.ScreenRefreshSettings(settings.screenRefresh);
            this.connectionMonitor = new AppSettings.ConnectionMonitorSettings(settings.connectionMonitor);
            this.security = new AppSettings.SecuritySettings(settings.security);
            this.timeZone = settings.timeZone ? settings.timeZone : SERVER_TZ;
            this.userManagement = new AppSettings.UserManagementSettings(settings.userManagement);
            this.securePhotoUpload = settings.securePhotoUpload;
            this.vls = new AppSettings.VlsSettings(settings.vls);
            this.aamvaSettings = new AppSettings.AamvaFeatureSettings(settings.aamvaSettings);
        }
    }
}

export module AppSettings {
    export interface IWebServiceSettings {
        serviceUrl: string;
    }

    export class ApiSettings implements IWebServiceSettings {
        public serviceUrl: string;
        public realtimeHubUrl: string;
        public signalrIntegration: string;
        public resourceIdentifier: string;
        public documentUpload: string;
        public graphApiUrl: string;

        constructor(settings?: ApiSettings) {
            if (settings) {
                this.serviceUrl = settings.serviceUrl;
                this.realtimeHubUrl = settings.realtimeHubUrl;
                this.signalrIntegration = settings.signalrIntegration;
                this.resourceIdentifier = settings.resourceIdentifier;
                this.documentUpload = settings.documentUpload;
                this.graphApiUrl = settings.graphApiUrl;
            }
        }
    }

    export class ScreenRefreshSettings {
        queueRefreshInterval: number;

        constructor(settings?: ScreenRefreshSettings) {
            if (settings) {
                this.queueRefreshInterval = settings.queueRefreshInterval;
            }
        }
    }

    export class ConnectionMonitorSettings {
        refreshInterval: number;
        retryInterval: number;

        constructor(settings?: ConnectionMonitorSettings) {
            if (settings) {
                this.refreshInterval = settings.refreshInterval;
                this.retryInterval = settings.retryInterval;
            }
        }
    }

    export class OmegaSettings implements IWebServiceSettings {
        serviceUrl: string;

        constructor(settings?: OmegaSettings) {
            if (settings) {
                this.serviceUrl = settings.serviceUrl;
            }
        }
    }

    export class SecuritySettings implements IWebServiceSettings {
        serviceUrl: string;
        tenant: string;
        authority: string;
        clientId: string;
        loginRedirectUri: string;
        postLogoutRedirectUri: string;
        cacheLocation: string;
        scope: string;
        resourceIdentifier: string;
        renewTokenInterval: number;
        httpStatusCodeRedirects: HttpStatusCodeRedirects[];
        autoLogoutTime: number;

        constructor(settings?: SecuritySettings) {
            if (settings) {
                this.serviceUrl = '';
                this.tenant = settings.tenant;
                this.authority = settings.authority;
                this.clientId = settings.clientId;
                this.loginRedirectUri = settings.loginRedirectUri;
                this.postLogoutRedirectUri = settings.postLogoutRedirectUri;
                this.cacheLocation = settings.cacheLocation;
                this.scope = settings.scope;
                this.resourceIdentifier = settings.resourceIdentifier;
                this.httpStatusCodeRedirects = settings.httpStatusCodeRedirects;
                this.renewTokenInterval = settings.renewTokenInterval;
                this.autoLogoutTime = settings.autoLogoutTime;
            }
        }
    }

    export class HelpSettings {
        linkBaseUrl: string;
        defaultHelpContentPage: string;

        constructor(settings?: HelpSettings) {
            if (settings) {
                this.linkBaseUrl = settings.linkBaseUrl;
                this.defaultHelpContentPage = settings.defaultHelpContentPage;
            }
        }
    }

    export class HelpDeskSettings implements IWebServiceSettings {
        serviceUrl: string;
        aamvaServiceUrl: string;
        integrationServiceUrl: string;

        constructor(settings?: HelpDeskSettings) {
            if (settings) {
                this.aamvaServiceUrl = settings.aamvaServiceUrl;
                this.integrationServiceUrl = settings.integrationServiceUrl;
            }
        }
    }

    export class HttpStatusCodeRedirects {
        statusCode: number;
        redirectUrl: string;
        accessDenied: boolean;
    }

    export class NotificationSettings {
        defaultNotificationMessageTitle: string;

        constructor(settings?: NotificationSettings) {
            if (settings) {
                this.defaultNotificationMessageTitle = settings.defaultNotificationMessageTitle;
            }
        }
    }

    // tslint:disable-next-line: max-classes-per-file
    export class VlsSettings {
        isEnabled = 'false';

        constructor(settings?: VlsSettings) {
            if (settings) {
                this.isEnabled = settings.isEnabled;
            }
        }
    }

    // tslint:disable-next-line: max-classes-per-file
    export class UserManagementSettings {
        usernameDomainSuffix: string;

        constructor(settings?: UserManagementSettings) {
            if (settings) {
                this.usernameDomainSuffix = settings.usernameDomainSuffix;
            }
        }
    }

    // tslint:disable-next-line: max-classes-per-file
    export class AamvaFeatureSettings {
        spexsRestEnabled: boolean;

        constructor(settings?: AamvaFeatureSettings) {
            if (settings) {
                this.spexsRestEnabled = settings.spexsRestEnabled;
            }
        }
    }
}

export const getAppSettings = () => new AppSettings(appSettings);

export const APP_SETTINGS_PROVIDERS: any[] = [{ provide: AppSettings, useFactory: getAppSettings }];
